import Vuex from "vuex";
import sitio from "@/store/sitio";

const store = new Vuex.Store({
  modules: {
    sitio: sitio
  },
});

export default store;